import { Autocomplete, Checkbox, ListItemText, TextField } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const MainGroupComp = ({
  options = [],
  xValue = [], // can be array or CSV string
  xtabIndex = "",
  xDisabled = false,
  setValue,
  objName,
  label,
  name,
  placeholder,
  onChangeCsv,
  onKeyUp,
  error,
  helperText, // optional: callback to receive CSV string
}) => {
  // normalize incoming value to array of Cds
  const normalized = Array.isArray(xValue)
    ? xValue.map(String)
    : typeof xValue === "string" && xValue.trim() !== ""
    ? xValue.split(",").map((v) => v.trim())
    : [];

  return (
    <div
      className="GCAutocompleteCheckboxFixSize"
      style={{ background: xDisabled ? "#e9ecef" : "transparent" }}
    >
      <Autocomplete
        tabIndex={xDisabled ? "" : xtabIndex}
        disabled={xDisabled}
        multiple
        size="small"
        options={options || []}
        getOptionLabel={(option) => option?.Name1 || ""}
        value={options.filter((grp) => normalized.includes(String(grp.Cd)))}
        isOptionEqualToValue={(option, value) =>
          String(option.Cd) === String(value.Cd)
        }
        onChange={(event, newValue) => {
          const selectedCds = newValue.map((grp) => String(grp.Cd));
          // update array in parent (objName)
          setValue((prev) => ({ ...prev, [objName]: selectedCds }));
          // (optional) also update CSV in parent if asked
          onChangeCsv?.(selectedCds.join(","));
        }}
        disableCloseOnSelect
        ListboxProps={{
          sx: { maxHeight: 260, overflowY: "auto", paddingY: 0 },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            name={name}
            placeholder={placeholder}
            size="small"
            InputLabelProps={{ shrink: true }}
            onKeyUp={onKeyUp}
            error={error}
            helperText={helperText}
            sx={{
              fontSize: "10px",
              "& .MuiOutlinedInput-root": {
                maxHeight: "32px",
                overflowY: "auto",
                border: "1px solid #ddd",
                padding: "0px !important",
                minWidth: "0px !important",
              },
              "& .MuiAutocomplete-input": {
                padding: "7.5px 4px 7.5px 5px !important",
              },
            }}
          />
        )}
        renderOption={(props, option, { selected }) => (
          <li
            {...props}
            sx={{
              height: "26px",
              minHeight: "26px",
              p: "0 8px",
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Checkbox
              size="small"
              icon={icon}
              checkedIcon={checkedIcon}
              checked={selected}
              tabIndex={-1}
              disableRipple
            />
            <ListItemText
              primary={option?.Name1}
              primaryTypographyProps={{
                fontSize: "12px",
                padding: "0px",
                margin: 0,
                lineHeight: "1.2",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            />
          </li>
        )}
      />
    </div>
  );
};
export default MainGroupComp;
